import { FC } from 'node_modules/@types/react';
import { Backdrop, Modal, Typography } from '@mui/material';
import ModalAction from 'src/components/Items/modal/Actions';

type Props = {
  text: string;
  title: string;
  action: string;
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
};

const ConfirmActionModal: FC<Props> = ({ open, action, text, title, onClose, onSubmit }) => {
  const handleSubmit = () => {
    onSubmit();
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose} closeAfterTransition BackdropComponent={Backdrop}>
      <div className='modal modal-400'>
        <div className='modal__title'>{title}</div>
        <Typography variant='body1'>{text}</Typography>
        <ModalAction handleSubmit={handleSubmit} handleClose={onClose} type='' action={action} />
      </div>
    </Modal>
  );
};

export default ConfirmActionModal;
